<template>
  <div class="sceneview_wraper">
    <public-control-title>
      <span slot="left">丨</span>
      <span slot="text" class="control-section-heading">{{ titleName }}</span>
      <img
        v-show="titleName != '场景' && titleName != '设备'"
        class="img_position"
        slot="img"
        src="~assets/img/controlpublic/changyong_tiaojia.png"
        alt
        role="button" tabindex="0" :aria-label="'添加'+titleName" @keydown.enter="btnHandle(titleName)"
        @click="btnHandle(titleName)"
      />
      <!-- 区域页面场景的title -->
      <span
        v-if="ifSenceShowZhanKai()"
        slot="text-right"
        @click="regionsencezhankaibtn"
        >{{ showRegionSenceText }}</span
      >
      <img
        v-if="ifSenceShowZhanKai()"
        slot="img-right"
        :src="imgURLState()"
        @click="regionsencezhankaibtn"
        alt
      />
      <!-- 常用页面场景的title    -->
      <span
        v-if="ifHomeSenceShowZhanKai()"
        slot="text-right"
        @click="homesencezhankaibtn"
        >{{ showHomeSenceText }}</span
      >
      <img
        v-if="ifHomeSenceShowZhanKai()"
        slot="img-right"
        :src="imgHomeURLState()"
        @click="homesencezhankaibtn"
        alt
      />
    </public-control-title>
  </div>
</template>

<script>
import {setHomeSceneExpandedPreference} from '@/common/app-preference'
import {
  judgeActivePage,
  publicFadeInOut,
  jieMianStateJudge
} from 'common/tool'
import publicControlTitle from 'components/content/contro-view/publiccontroltitle'
import { request } from '../../../network/request'
export default {
  name: 'viewTitle',
  components: {
    publicControlTitle
  },
  data() {
    return {
      //（展开收起功能块）
      showRegionSenceText: this.$store.state.publicinfo.showRegionSenceText, ////组件重新渲染的时候，把仓库的值拿过来赋初值，解决页面突然插入数据或减少数据出现的状态不同步。
      showHomeSenceText: this.$store.state.publicinfo.showHomeSenceText
    }
  },
  props: {
    titleName: String
  },
  methods: {
    btnHandle(titleName) {
      console.log('加号被点击了' + titleName)

      if (!jieMianStateJudge()) return ///界面管理状态判断

      if (titleName === '常用场景') {
        this.$router.push('HomeChangeScene')
      } else if (titleName === '常用设备') {
        this.$router.push('HomeChangeDevice')
      }
    },
    ifSenceShowZhanKai() {
      ////判断是不是区域页面调用的Title组件，并判断是否还有未显示的子元素个数 //（展开收起功能块）
      if (
        this.titleName == '场景' &&
        this.$store.state.publicinfo.regionSenceCount > 0
      ) {
        return true
      }
      return false
    },
    ifHomeSenceShowZhanKai() {
      ///判断是不是常用页面调用的Title 并判断是否还有未显示的子元素个数 （展开收起功能块）
      if (
        this.titleName == '常用场景' &&
        this.$store.state.publicinfo.homeSenceCount > 0
      ) {
        return true
      }
      return false
    },
    regionsencezhankaibtn() {
      //（展开收起功能块）
      if (this.showRegionSenceText === '展开') {
        this.showRegionSenceText = '收起'
      } else {
        this.showRegionSenceText = '展开'
      }
      this.$store.commit('updataShowRegionSenceText', this.showRegionSenceText) //同步提交仓库
      // console.log(this.$store.state.publicinfo.showRegionSenceText)
    },
    homesencezhankaibtn() {
      //（展开收起功能块）
      if (this.showHomeSenceText === '展开') {
        this.showHomeSenceText = '收起'
      } else {
        this.showHomeSenceText = '展开'
      }
      setHomeSceneExpandedPreference(this.showHomeSenceText === '收起')
      this.$store.commit('updataShowHomeSenceText', this.showHomeSenceText) //同步提交仓库
      // console.log(this.$store.state.publicinfo.showRegionSenceText)
    },
    imgURLState() {
      //（展开收起功能块）
      if (this.showRegionSenceText == '展开') {
        return require(`assets/img/controlpublic/changyong_xiala.png`)
      } else {
        return require(`assets/img/controlpublic/diankai_shangfan.png`)
      }
    },
    imgHomeURLState() {
      //（展开收起功能块）
      if (this.showHomeSenceText == '展开') {
        return require(`assets/img/controlpublic/changyong_xiala.png`)
      } else {
        return require(`assets/img/controlpublic/diankai_shangfan.png`)
      }
    }
  },
  mounted() {}
}
</script>

<style>
.control-section-heading { font-weight: 700; }
.img_position {
  display: block;
  width: 22px;
  height: 22px;
  /* margin-bottom: -7px; */
}
.sceneview_conte {
  min-width: 100%;
  min-height: 100px;
}
</style>
